import * as types from './types'
import {RSAA} from "redux-api-middleware";

export function loadQuestions(instance_id) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/instance/${instance_id}/questions`,
            method: 'POST',
            headers: types.defaultHeaders,
            types: [
                { type: types.KNOWLEDGE_QUESTIONS_LOAD, meta: { instanceId: instance_id } },
                types.KNOWLEDGE_QUESTIONS_LOAD_SUCCESS,
                types.KNOWLEDGE_QUESTIONS_LOAD_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
}


function shouldListQuestions(state) {

    const resources = state.knowledgeQuestions;

    if (!resources.list) {
        return true
    } else if (resources.loading) {
        return false
    } else {
        return resources.loadingInvalid;
    }
}

export function listQuestionsIfNeeded(instanceId) {
    return (dispatch, getState) => {
        if (shouldListQuestions(getState())) {
            return dispatch(loadQuestions(instanceId));
        }
    }
}